import {
  CartGuards,
  ContactInformationGuards,
  ReviewGuards,
  getObjectKeysAsObject,
  CardPaymentGuards,
  WalletGuards,
  RewardsPaymentGuards,
} from "@capone/checkout";
import { ActivityCommonGuards } from "./common";
import {
  ActivityTravelerGuards,
  ActivityAdditionalDetailsGuards,
} from "../../../../checkout";

export const Guards = {
  ...CartGuards,
  ...ContactInformationGuards,
  ...ReviewGuards,
  ...CardPaymentGuards,
  ...RewardsPaymentGuards,
  ...WalletGuards,
  ...ActivityCommonGuards,
  ...ActivityTravelerGuards,
  ...ActivityAdditionalDetailsGuards,
};

export const GuardTypes = getObjectKeysAsObject(Guards);
